module.exports = __webpack_public_path__ + "static/media/31JFA6.9fc8e014.jpg";